import type { ReactNode } from 'react';
import { matchRoutes, Navigate, useLocation } from 'react-router-dom';
import { productionFlows } from '../../config/flowAvailability';
import { useEnvContext } from '../../context/EnvironmentContext';

const FlowAvailabilityGate = ({ children }: { children: ReactNode }) => {
    const { isEmulatedProduction } = useEnvContext();

    const location = useLocation();
    const match = matchRoutes(
        Object.keys(productionFlows).map(flow => ({ path: `/${flow}/*`, id: flow })),
        location,
    );
    const flow = match?.[0].route.id;
    const isProductionHost = window.location.hostname === 'start.memoryos.com' || isEmulatedProduction;

    if (!isProductionHost || !flow || productionFlows[flow] !== false) {
        return <>{children}</>;
    }

    // A disabled redirect target must not create an endless navigation loop.
    if (!productionFlows['new-h2']) {
        return <main style={{ padding: '24px', textAlign: 'center' }}>
            <p>This page is currently unavailable.</p>
        </main>;
    }

    return <Navigate to={{ pathname: '/new-h2', search: location.search, hash: location.hash }} replace />;
};

export default FlowAvailabilityGate;
